import React from 'react'

const Main: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => <main>{children}</main>

export default Main
